import React, { useContext } from 'react';
import { SalesforceContext, Steps, CustomerTypes } from 'src/context/salesforce-context';
import { OnboardingSummaryContext } from 'src/context/onboarding-summary-context';
import TealiumEvents from 'src/helpers/tealium-events';
import { formatPhoneNumberText, formatIDNumberText } from 'src/helpers/formatting';
import './delivery-addresses-summary.scss';
import { CONSUMER_TYPE } from 'src/services/salesforce.service';

const maxNonDefaultAddresses = 19;
var numAddresses = 1;

export default function DeliveryAddressesSummary(props) {
  const {
    uniqueTerminals,
    deviceDeliveryDetails,
    setDeviceDeliveryDetails,
    customerType,
    lead,
  } = useContext(SalesforceContext);
  const { totalNumberOfDevices, deviceQuantitiesToDisplay } = useContext(OnboardingSummaryContext);

  const removeDeviceDelivery = (deliveryToRemove) => {
    let deliveriesWithAddressCopy = deviceDeliveryDetails.filter(
      (delivery) => delivery !== deliveryToRemove,
    );
    setDeviceDeliveryDetails(deliveriesWithAddressCopy);
  };

  let deviceQuantitiesToDisplayValue = deviceQuantitiesToDisplay();

  let totalNumberOfDevicesWithAddresses = deviceDeliveryDetails
    .flatMap((deviceDelivery) => Object.values(deviceDelivery.devices))
    .reduce((quantityA, quantityB) => quantityA + quantityB, 0);

  let numberOfNonDefaultAddresses = deviceQuantitiesToDisplayValue.filter(
    (deviceQuantity) => deviceQuantity.address_type !== 'business',
  ).length;

  const editNonDefaultDeviceQuantity = (deviceQuantity) => {
    props.setModalInitialDeviceQuantity(deviceQuantity);
    //TODO: remove this props.setDeliveryAddressIsNonDefault
    props.setDeliveryAddressIsNonDefault(true);
    props.setShowAddressModal(true);
  };

  return (
    <>
      <div
        className={`DeliveryAddressesSummary input-area-container delivery_address_container ${
          !props.isMobile ? 'container' : ''
        }`}
      >
        {!props.isMobile && (
          <span>
            <div className="spacer-quarter" />
            <div className="input-area-container-heading has-text-left deliver-address-heading ">
              <div>Delivery address</div>
            </div>

            <div className="subtitle has-text-left deliver-address-subheading sub-heading delivery-address-subheading">
              <div>
                {totalNumberOfDevices > 1
                  ? customerType !== CustomerTypes.normal && customerType !== CustomerTypes.pos
                    ? 'The customer has chosen more than 1 device, they can deliver it to multiple addresses. '
                    : 'You’ve chosen more than 1 device, you can deliver it to multiple addresses. '
                  : ''}

                <p>Devices will be shipped within 5 business days on application approval</p>
              </div>
              <div className="spacer-quarter" />
            </div>
          </span>
        )}
        <div className="delivery-address-subtext is-hidden-desktop">
          {totalNumberOfDevices > 1
            ? (lead.consumerType === CONSUMER_TYPE.assistant &&
                customerType !== CustomerTypes.pos) ||
              customerType === CustomerTypes.agent
              ? 'The customer has chosen more than 1 device, they can deliver it to multiple addresses. '
              : 'You’ve chosen more than 1 device, you can deliver it to multiple addresses. '
            : ''}
          Devices will be shipped within 5 business days on application approval
        </div>

        <div className="columns is-multiline">
          {deviceQuantitiesToDisplayValue.map((delivery, addressIndex) => {
            const addressLine1 = ['street', 'building', 'suburb']
              .map((addressItem) => delivery?.[addressItem])
              .filter((addressValue) => addressValue)
              .map((item, addressItemIndex) => (
                <p key={`${addressIndex} - ${addressItemIndex}`}>{item + ', '}</p>
              ));
            let count = 0;
            const addressLine2 = ['region', 'state', 'zip_code']
              .map((addressItem) => delivery?.[addressItem])
              .filter((addressValue) => {
                if (addressValue) {
                  return true;
                } else {
                  count++;
                  return false;
                }
              })
              .map((item, addressItemIndex) => (
                <p key={`${addressIndex} - ${addressItemIndex + 2}`}>
                  {addressItemIndex !== 2 - count ? item + ', ' : item}
                </p>
              ));

            const numDevices = Object.values(delivery.devices).reduce(
              (quantityA, quantityB) => quantityA + quantityB,
              0,
            );

            const devices = Object.keys(delivery.devices)
              .filter((deviceId) => delivery.devices[deviceId] > 0)
              .map((deviceId) => uniqueTerminals[deviceId]?.name)
              .join(', ');

            return (
              <div
                key={addressIndex}
                className={`column section-right ${
                  props.isMobile ? 'is-full' : 'is-full delivery-address-info has-padding-40-27'
                } ${delivery.address_type === 'business' ? 'default-address' : ''}`}
              >
                {delivery.address_type === 'business' && (
                  <div className="has-padding-7 has-padding-right-0">
                    <div className="subtext-heading ">
                      Default address{' '}
                      <span className="subtext-heading-small">
                        {!props.isMobile ? (
                          '(Unassigned devices are sent to this address)'
                        ) : (
                          <p>(Unassigned devices are sent to this address)</p>
                        )}

                        <span
                          className="edit-button is-pulled-right is-hidden-mobile default-icon"
                          onClick={() => {
                            TealiumEvents.confirmClickEditAddress(
                              Steps.BUSINESS_ADDRESS,
                              customerType,
                            );
                            props.quickNavigate(Steps.YOUR_BUSINESS, Steps.BUSINESS_ADDRESS);
                          }}
                          automationid="Onboarding_Create_Account_Confirm_Delivery_Addresses_Span_Edit_Navigate_To_Your_Business"
                        />

                        <span
                          className="edit-button is-pulled-right is-hidden-desktop is-hidden-tablet default-icon-mobile"
                          onClick={() => {
                            TealiumEvents.confirmClickEditAddress(
                              Steps.YOUR_BUSINESS,
                              customerType,
                            );
                            props.quickNavigate(Steps.YOUR_BUSINESS);
                          }}
                          automationid="Onboarding_Create_Account_Confirm_Delivery_Addresses_Span_Edit_Navigate_To_Your_Business"
                        />
                      </span>
                    </div>
                  </div>
                )}
                {delivery.address_type !== 'business' && (
                  <div className="heading-container has-padding-left-7">
                    <div>{'Address ' + (addressIndex + 1)}</div>
                    <div className="edit-icon">
                      <div>
                        <span
                          className="edit-button has-margin-right-4 edit-bottom-margin"
                          onClick={() => {
                            editNonDefaultDeviceQuantity(delivery);
                          }}
                          automationid={`Onboarding_Create_Account_Confirm_Delivery_Addresses_Span_Edit_Delivery_Address_${addressIndex}`}
                        />
                        <span
                          className="remove-button-no-border"
                          onClick={() => {
                            removeDeviceDelivery(delivery);
                            TealiumEvents.confirmRemoveAddress(
                              deviceQuantitiesToDisplayValue.length - 1,
                              customerType,
                            );
                          }}
                          automationid={`Onboarding_Create_Account_Confirm_Delivery_Addresses_Span_Remove_Delivery_Address_${addressIndex}`}
                        ></span>
                      </div>
                    </div>
                  </div>
                )}

                {props.isMobile && (
                  <div className="columns">
                    <div className="column is-4">
                      <p className="tiny-sub-heading">Address</p>
                      <div className="delivery-address-line">{addressLine1}</div>
                      <div className="delivery-address-line">{addressLine2}</div>
                    </div>

                    <div className="column is-4">
                      <div className="text-block">
                        <p className="tiny-sub-heading">Trading name</p>
                        <p className="tiny-text-body">{delivery.trading_as}</p>
                      </div>
                    </div>

                    <div className="column is-4">
                      <div className="text-block">
                        <p className="tiny-sub-heading">Recipient name</p>
                        <p className="tiny-text-body">{delivery.manager_name}</p>
                      </div>
                    </div>

                    <div className="column is-4">
                      <div className="text-block">
                        <p className="tiny-sub-heading">Recipient ID number</p>
                        <p className="tiny-text-body">{formatIDNumberText(delivery.id_number)}</p>
                      </div>
                    </div>

                    <div className="column is-4">
                      <div className="text-block">
                        <p className="tiny-sub-heading">Recipient cell number</p>
                        <p className="tiny-text-body">
                          {formatPhoneNumberText(delivery.phone_cell || delivery.phone_work)}
                        </p>
                      </div>
                    </div>

                    <div className="column is-4">
                      <div className="text-block">
                        <p className="tiny-sub-heading">Recipient work number</p>
                        <p className="tiny-text-body">
                          {formatPhoneNumberText(delivery.phone_work || delivery.phone_cell)}
                        </p>
                      </div>
                    </div>

                    <div className="column is-4">
                      <div className="text-block">
                        <p className="tiny-sub-heading">Devices</p>
                        <p className="tiny-text-body">{devices}</p>
                      </div>
                    </div>

                    <div className="column is-4">
                      <div className="text-block">
                        <p className="tiny-sub-heading">Number of devices</p>
                        <p className="tiny-text-body">{numDevices}</p>
                      </div>
                    </div>
                  </div>
                )}

                {!props.isMobile && (
                  <>
                    <div className="columns">
                      <div className="column is-4">
                        <p className="tiny-sub-heading">Address</p>
                        <div className="delivery-address-line">{addressLine1}</div>
                        <div className="delivery-address-line">{addressLine2}</div>
                      </div>

                      <div className="column is-4">
                        <div className="text-block">
                          <p className="tiny-sub-heading">Recipient ID number</p>
                          <p className="tiny-text-body">{formatIDNumberText(delivery.id_number)}</p>
                        </div>
                      </div>

                      <div className="column is-4">
                        <div className="text-block">
                          <p className="tiny-sub-heading">Devices</p>
                          <p className="tiny-text-body">{devices}</p>
                        </div>
                      </div>
                    </div>

                    <div className="columns">
                      <div className="column is-4">
                        <div className="text-block">
                          <p className="tiny-sub-heading">Trading name</p>
                          <p className="tiny-text-body">{delivery.trading_as}</p>
                        </div>
                      </div>

                      <div className="column is-4">
                        <div className="text-block">
                          <p className="tiny-sub-heading">Recipient cell number</p>
                          <p className="tiny-text-body">
                            {formatPhoneNumberText(delivery.phone_cell || delivery.phone_work)}
                          </p>
                        </div>
                      </div>

                      <div className="column is-4">
                        <div className="text-block">
                          <p className="tiny-sub-heading">Number of devices</p>
                          <p className="tiny-text-body">{numDevices}</p>
                        </div>
                      </div>
                    </div>

                    <div className="columns">
                      <div className="column is-4">
                        <div className="text-block">
                          <p className="tiny-sub-heading">Recipient name</p>
                          <p className="tiny-text-body">{delivery.manager_name}</p>
                        </div>
                      </div>

                      <div className="column is-4">
                        <div className="text-block">
                          <p className="tiny-sub-heading">Recipient work number</p>
                          <p className="tiny-text-body">
                            {formatPhoneNumberText(delivery.phone_work || delivery.phone_cell)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </>
                )}

                {delivery.address_type !== 'business' && <div className="grey-line"></div>}
              </div>
            );
          })}
          <div className="spacer-quarter" />
          <div className={'add-address-container '}>
            <div
              className={
                'address-inner-container ' +
                (!(
                  totalNumberOfDevices > 0 &&
                  totalNumberOfDevicesWithAddresses < totalNumberOfDevices &&
                  numberOfNonDefaultAddresses < maxNonDefaultAddresses
                )
                  ? 'disabled'
                  : '')
              }
              disabled={
                !(
                  totalNumberOfDevices > 0 &&
                  totalNumberOfDevicesWithAddresses < totalNumberOfDevices &&
                  numberOfNonDefaultAddresses < maxNonDefaultAddresses
                )
              }
              onClick={() => {
                if (
                  totalNumberOfDevices > 0 &&
                  totalNumberOfDevicesWithAddresses < totalNumberOfDevices &&
                  numberOfNonDefaultAddresses < maxNonDefaultAddresses
                ) {
                  TealiumEvents.confirmClickAddAddress(customerType);
                  props.setShowAddressModal(true);
                  {
                    numAddresses = numAddresses + 1;
                  }
                }
              }}
            >
              <div
                className="button add-device-button"
                automationid={`Onboarding_Create_Account_Confirm_Delivery_Addresses_Div_Add_Delivery_Address`}
              />
              <div className="tiny-sub-heading add-address-text">Add address</div>
            </div>
          </div>
          {totalNumberOfDevicesWithAddresses >= totalNumberOfDevices && (
            <div className="all-devices-assigned">All devices assigned</div>
          )}
        </div>
        <div className="spacer-quarter" />
      </div>
    </>
  );
}
